export const BASE_URL = 'https://yoursocial-dev.herokuapp.com';

export const USER_DETAILS_URL = `${BASE_URL}/public/user/`;
export const SIGN_UP_URL = `${BASE_URL}/sign-up`;
export const SIGN_IN_URL = `${BASE_URL}/sign-in`;
export const DELETE_USER_URL = `${BASE_URL}/auth/delete`;
export const RECAPTCHA_URL = `${BASE_URL}/verify-human`;
export const EXCISTENCE_URL = `${BASE_URL}/search/existence`;
export const UPDATE_PROFILE_URL = `${BASE_URL}/auth/`;
export const SOCIAL_MEDIA_URL = `${BASE_URL}/auth/social-links`;
export const ACHIEVEMENTS_URL = `${BASE_URL}/auth/achievement`;
export const PHTOTS_URL = `${BASE_URL}/auth/photos`;
export const LINKS_URL = `${BASE_URL}/auth/links`;
export const PROFILE_IMAGE_URL = `${BASE_URL}/auth/profilePicture`;
export const IMAGE_URL = `https://api.imgur.com/3/image`;
